import { Button } from '@domain-group/suit-theme'

import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { confirmAction } from '@functions/entity'

import useArtworkReview from '@hooks/useArtworkReview'
import useArtworkReviews from '@hooks/useArtworkReviews'
import useCurrentUser from '@hooks/useCurrentUser'

import type { ArtworkModel } from '@models/types'

interface CreateArtworkReviewButtonProps {
  artwork: ArtworkModel,
  boxProps?: object,
  buttonStyle?: object,
  buttonVariant?: string,
}

const CreateArtworkReviewButton = (props: CreateArtworkReviewButtonProps) => {
  const {
    artwork, boxProps, buttonStyle, buttonVariant,
  } = props

  const { currentUser } = useCurrentUser()

  const {
    callbacks: { createArtworkReview },
    creating,
  } = useArtworkReview()

  const artworkReviewsPayload = useArtworkReviews({
    filters: {
      artwork_id: artwork.id,
      status_key: 'approved',
      user_id: currentUser.id,
    },
    performHttpRequests: true,
  })

  const { hasFilteredArtworkReviews, loading } = artworkReviewsPayload

  const createArtworkReviewPayload = {
    callbacks: {
      actionFn: createArtworkReview,
    },
    options: {
      entityParams: { artwork_id: artwork.id, user_id: currentUser.id, status_title: 'Approved' },
    },
    strings: {
      actionString: 'approve',
      entityName: 'artwork',
    },
  }

  return (
    <Button
      onClick={() => confirmAction(createArtworkReviewPayload)}
      // @ts-expect-error TS2322
      buttonStyle={buttonVariant || 'secondaryCreate'}
      icon={<FontAwesomeIcon icon={faCheckCircle} />}
      loading={creating || loading}
      size="medium"
      style={hasFilteredArtworkReviews ? {
        backgroundColor: '#f8f8f8', cursor: 'default', pointerEvents: 'none', ...buttonStyle,
      } : { ...buttonStyle }}
      width="auto"
      {...boxProps}
    >
      {hasFilteredArtworkReviews ? 'Approved' : 'Approve Artwork'}
    </Button>
  )
}

export default CreateArtworkReviewButton
